import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Topbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Navbar */}
      <header className="sticky top-0 left-0 w-full z-50">
        <div className="backdrop-blur bg-black/60 p-6 flex justify-between items-center">
          <Link to="/">
            <img
              src="https://cdn.prod.website-files.com/638fda8f8e2f041af84cb5a7/6824d581ae24f69d45e26536_beem%20logo%203.png"
              alt="Beem Logo"
              className="w-28"
              style={{ cursor: 'pointer' }}
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="space-x-6 hidden md:block">
            <a href="#features" className="hover:underline">Features</a>
            <a href="#faqs" className="hover:underline">FAQs</a>
            <a href="#plans" className="hover:underline">Pricing</a>
            <Link to="/sign-in" className="hover:underline">Log In</Link>
          </nav>

          {/* Desktop CTA */}
          <Link to="/sign-up"
            className="px-4 py-2 rounded-xl custom-btn text-white font-semibold hidden md:inline"
          >
            Start For Free
          </Link>

          {/* Mobile toggle */}
          <button
            id="menuToggle"
            className="md:hidden text-white ml-2"
            onClick={() => setOpen(!open)}
            aria-label="Open mobile menu"
          >
            {/* Hamburger icon */}
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </header>

      {/* Mobile Nav */}
      {open && (
        <div
          id="mobileMenu"
          className="sticky h-screen inset-0 bg-black/90 text-white flex items-center justify-center z-[60]"
        >
          <button
            className="absolute top-6 right-6 text-3xl"
            onClick={() => setOpen(false)}
            aria-label="Close mobile menu"
          >
            &times;
          </button>
          <div className="flex flex-col items-center space-y-6 text-xl">
            <a href="#features" className="hover:underline" onClick={() => setOpen(false)}>Features</a>
            <a href="#faqs" className="hover:underline" onClick={() => setOpen(false)}>FAQs</a>
            <a href="#plans" className="hover:underline" onClick={() => setOpen(false)}>Pricing</a>
            <Link to="/sign-in" className="hover:underline" onClick={() => setOpen(false)}>Log In</Link>
            <Link to="/sign-up"
              className="px-4 py-2 rounded-xl custom-btn text-white font-semibold"
              onClick={() => setOpen(false)}   >
              Start For Free
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
